import React, { forwardRef } from "react";
import { Textarea } from "@chakra-ui/react";

type InputTextAreaProps = {
  name: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  fontSize?: string;
  height?: string;
  paddingY?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  dataTestId?: string;
  maxLength?: number;
};

export const InputTextArea = forwardRef<HTMLTextAreaElement, InputTextAreaProps>((props, ref) => {
  const {
    name,
    value,
    placeholder,
    disabled,
    fontSize = "lg",
    height = "auto",
    paddingY = 2,
    onChange,
    onBlur,
    maxLength,
  } = props;
  const dataTestId = props.dataTestId ?? name;

  return (
    <Textarea
      data-testid={dataTestId}
      ref={ref}
      borderColor="gray.500"
      name={name}
      value={value}
      placeholder={placeholder}
      _disabled={{
        opacity: 1,
      }}
      backgroundColor={disabled ? "gray.50" : "white"}
      disabled={disabled}
      isReadOnly={disabled}
      fontSize={fontSize}
      height={height}
      paddingY={paddingY}
      maxLength={maxLength}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      _hover={{
        borderColor: disabled ? "gray.500" : "blue.500",
      }}
    />
  );
});
